/* eslint-disable no-throw-literal */
import {
  AREA_ALL_GET,
  AREA_ALL_GET_SUCCESS,
  AREA_ALL_GET_FAILURE
} from './mutation-types'

export default {
  state: {
    areas: []
  },
  getters: {
    areas: state => {
      return state.areas
    }
  },
  actions: {
    [AREA_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/areas', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(AREA_ALL_GET_FAILURE, res.data)
          } else {
            commit(AREA_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [AREA_ALL_GET_FAILURE] (state, data) {
      console.log('AREA_ALL_GET_FAILURE')
    },
    [AREA_ALL_GET_SUCCESS] (state, data) {
      console.log('AREA_ALL_GET_SUCCESS')
      state.areas = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/area.js